module.exports = __webpack_public_path__ + "img/ems.30ff6c37.jpg";